module.exports = __webpack_public_path__ + "static/img/bjs.9fc84ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/bjs.png
// module id = XZYL
// module chunks = 0